module.exports = __webpack_public_path__ + "static/media/City Life - DK Chocolate_LT Grey.c6a446fa.jpg";